export enum GRReportNameEnum {
  MESSAGES = 'messages',
  CLICKERS = 'clickers',
  CLICK_TRACKING = 'click_tracking',
  OPTOUTS = 'optouts',
  REPLIES = 'replies',
  CAMPAIGN_ROLLUP = 'campaign_rollup',
  CAMPAIGN_MONTHLY = 'campaign_monthly',
  CONVERSATIONS = 'conversations',
  CAMPAIGN_DAILY = 'campaign_daily',
  UNIFIN_EXCLUSIONS = 'unifin_exclusions',
  UNIFIN_MESSAGE_STATS = 'unifin_message_stats',
  MESSAGES_QUARTER_HOURLY = 'messages_quarter_hourly',
}
